import type { RenderContext, RenderField } from "../types.ts";
import { renderChoiceGroup } from "./choice-group.ts";

export const renderCheckboxGroupField = (
  field: RenderField<"CHECKBOX_GROUP">,
  context: RenderContext,
): HTMLElement => {
  return renderChoiceGroup(field, context);
};
